var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgSomeInstagram = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.498 7.111h7.479a5.163 5.163 0 0 1 5.164 5.156v7.466a5.15 5.15 0 0 1-1.512 3.646 5.17 5.17 0 0 1-3.652 1.51h-7.479a5.164 5.164 0 0 1-5.164-5.156v-7.466c0-1.368.544-2.679 1.513-3.646a5.17 5.17 0 0 1 3.651-1.51M12.32 8.89c-.85 0-1.665.337-2.267.937a3.2 3.2 0 0 0-.938 2.263v7.822a3.2 3.2 0 0 0 3.205 3.2h7.835c.85 0 1.665-.337 2.267-.937.6-.6.938-1.414.938-2.263V12.09a3.2 3.2 0 0 0-3.205-3.2zm8.592 1.333a1.114 1.114 0 0 1 1.113 1.111 1.11 1.11 0 0 1-1.113 1.111 1.114 1.114 0 0 1-1.113-1.11 1.11 1.11 0 0 1 1.113-1.112m-4.674 1.334c1.18 0 2.313.468 3.147 1.301a4.44 4.44 0 0 1 0 6.286 4.456 4.456 0 0 1-6.295 0 4.44 4.44 0 0 1 0-6.286 4.46 4.46 0 0 1 3.148-1.301m0 1.777A2.673 2.673 0 0 0 13.566 16a2.665 2.665 0 0 0 2.672 2.667 2.665 2.665 0 1 0 0-5.333"
  })));
};
const Memo = /*#__PURE__*/memo(SvgSomeInstagram);
export default Memo;